__turbopack_context__.v({
  "article": "Article-module-scss-module__-tJDUa__article",
  "banner": "Article-module-scss-module__-tJDUa__banner",
  "content": "Article-module-scss-module__-tJDUa__content",
  "showBlock": "Article-module-scss-module__-tJDUa__showBlock",
});
